import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { align }) => ({
  label: {
    textAlign: align,
  },
}));
